// extracted by mini-css-extract-plugin
export default {"accordionHeader":"yGUNiaKQ3pOlrHGLb5qAv","accordionTitle":"_2baKviMMsNfyvvcBJYLA2A","accordionToggle":"_3MZk7Z3k69RK6hNNQUpal0"};